// Breadcrumb metadata for logged-in routes: the menu section a page belongs to, its
// parent page (for detail/edit pages) and the icon shown in the top bar.
const RISK = "menu_risk_management";
const ADMIN = "menu_administration";
const PLATFORM = "menu_platform";

const ROUTE_META = {
  "/": { label: "dashboard", icon: "icon-Dashboard" },
  "/risks": { section: RISK, label: "risks_plural", icon: "icon-Risico" },
  "/viewrisk": { section: RISK, parent: "/risks", label: "risk", icon: "icon-Risico" },
  "/measures": { section: RISK, label: "measures", icon: "icon-Maatregelen" },
  "/applicability": { section: RISK, label: "soa", icon: "icon-SoA" },
  "/risk-review": { section: RISK, label: "risk_review", icon: "icon-risk-review" },
  "/prepare-evaluation": { section: RISK, label: "rep_menu", icon: "icon-evaluation" },
  "/copilot": { section: RISK, label: "menu_copilot", icon: "icon-stars1" },
  "/projects": { section: ADMIN, label: "domains", icon: "icon-Projecten" },
  "/addproject": { section: ADMIN, parent: "/projects", label: "add_domain", icon: "icon-Projecten" },
  "/editproject": { section: ADMIN, parent: "/projects", label: "edit_domain", icon: "icon-Projecten" },
  "/users": { section: ADMIN, label: "users", icon: "icon-Gebruikers" },
  "/adduser": { section: ADMIN, parent: "/users", label: "add_user", icon: "icon-Gebruikers" },
  "/organizations": { section: ADMIN, label: "organizations", icon: "icon-Organisaties" },
  "/addorg": { section: ADMIN, parent: "/organizations", label: "add_organization", icon: "icon-Organisaties" },
  "/editorg": { section: ADMIN, parent: "/organizations", label: "update_organization", icon: "icon-Organisaties" },
  "/risktemplates": { section: ADMIN, label: "risk_templates", icon: "icon-Template" },
  "/addrisktemplate": { section: ADMIN, parent: "/risktemplates", label: "add_risk_template", icon: "icon-Template" },
  "/editrisktemplate": { section: ADMIN, parent: "/risktemplates", label: "edit_risk_template", icon: "icon-Template" },
  "/environments": { section: PLATFORM, label: "environments", icon: "icon-sitemap1" },
  "/addenvironment": { section: PLATFORM, parent: "/environments", label: "add_environment", icon: "icon-sitemap1" },
  "/viewenvironment": { section: PLATFORM, parent: "/environments", label: "manage_environment", icon: "icon-sitemap1" },
  "/manageenvironment": { section: PLATFORM, parent: "/environments", label: "manage_environment", icon: "icon-sitemap1" },
  "/activities": { section: PLATFORM, label: "statistics", icon: "icon-statistics" },
  "/requests": { section: PLATFORM, label: "requests", icon: "icon-requests" },
  "/mailing": { section: PLATFORM, label: "mailing.title", icon: "icon-mail" },
  "/copilotmanagement": { section: PLATFORM, label: "menu_copilot", icon: "icon-stars1" },
  "/addcopilot": { section: PLATFORM, parent: "/copilotmanagement", label: "menu_copilot", icon: "icon-stars1" },
  "/editcopilot": { section: PLATFORM, parent: "/copilotmanagement", label: "menu_copilot", icon: "icon-stars1" },
  "/subscriptions": { label: "subscriptions", icon: "icon-subscriptions" },
  "/edituser": { label: "settings", icon: "icon-Gebruiker" },
  "/help": { label: "help.title", icon: "icon-idea" },
};

export const getRouteMeta = (pathname) => {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  return ROUTE_META[path] || null;
};

export const getInitials = (name = "") => {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "?";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
};
